import { useState } from "react";
import CategoryTree from "./CategoryTree";
import FilterList from "./FilterList";
import {
  AIFilter,
  AIFilterCategory,
} from "@/interfaces/ai-filter.interface";

interface Props {
  onSelectFilter?: (item: AIFilter) => void;
}

export default function AIFilterManagement({ onSelectFilter }: Props) {
  const [category, setCategory] = useState<AIFilterCategory>();

  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full w-1/4 max-w-[300px] overflow-auto border-r-1 border-gray-300">
        <CategoryTree onChange={setCategory} />
      </div>
      <div className="h-full flex-1 overflow-auto">
        <FilterList category={category} onSelect={onSelectFilter} />
      </div>
    </div>
  );
}
